<template>
  <div class="card-item">
    <div class="title-box">
      <span class="title-text">工作室基本信息</span>
      <span class="btn-action-group" style="color: #9d9d9d; font-size: 14px">
        <!-- 请先填写基本信息并保存
        <template v-if="$store.state.role === 'school-role' && (oldInfos && oldInfos?.auditState=='1' || oldInfos?.auditState=='2')">
          <a-button type="primary" class="btn-action" @click="edit">编辑</a-button>
        </template> -->
      </span>
    </div>
    <div>
      <div class="mt30">
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 工作室名称
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              placeholder="请输入工作室名称"
              :maxLength="100"
              v-model="info.name"
              :disabled="isEdit || !isbj"
            />
          </div>
        </div>
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 申报年份
          </div>
          <div class="pl16">
            <a-date-picker
              placeholder="请选择申报年份"
              v-model="info.applyYear"
              :disabled="isEdit"
              :open="yearShowOne"
              :locale="locale"
              :format="'YYYY'"
              mode="year"
              @openChange="openChangeOne"
              @panelChange="panelChangeOne"
              class="form-item-right"
            />
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item" style="width: 100%;">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 工作室地点
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              :maxLength="50"
              placeholder="请输入工作室地点"
              v-model="info.address"
              :disabled="isEdit"
            />
            <!--  -->
          </div>
        </div>
        
      </div>
      <div class="mt30">
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 场所面积
          </div>
          <div class="pl16 plflex">
            <a-input
              class="input-style-2"
              type="text"
              pattern="[1-9]\d*"
              placeholder="请输入场所面积"
              v-model="info.acreage"
              style="width: 85%"
              :disabled="isEdit"
            />
            <span class="text2">平米</span>
          </div>
          <!-- -->
        </div>
         <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 建设日期
          </div>
          <div class="pl16">
            <a-date-picker
              placeholder="请选择建设日期"
              v-model="info.foundTime"
              :disabled="isEdit"
              :format="'YYYY-MM-DD'"
              :locale="locale"
              class="form-item-right"
            />
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item" style="width: 100%;">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 所属部门
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              placeholder="请输入所属部门"
              :maxLength="100"
              v-model="info.belongDepartment"
              :disabled="isEdit"
            />
          </div>
        </div>
       
      </div>
      <div class="mt30">
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f"></span>全校师生对工作室知晓度
          </div>
          <div class="pl16 flex align-items-center">
            <a-input-number
              v-model="info.tsSzgzsKnow"
              precision="0"
              :disabled="isEdit"
              class="percentage-text"
            />
            <span class="text2">%</span>
          </div>
        </div>
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f"></span>全校师生对工作室服务满意度
          </div>
          <div class="pl16 flex align-items-center">
            <a-input-number
              v-model="info.tsSzgzsSatisfied"
              precision="0"
              :disabled="isEdit"
              class="percentage-text"
            />
            <span class="text2">%</span>
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f"></span>项目被省级或国家级媒体报道次数
          </div>
          <div class="pl16 flex align-items-center">
            <a-input-number
              v-model="info.reportNum"
              precision="0"
              :disabled="isEdit"
              class="percentage-text"
            />
            <!-- <span class="percentage-sign" v-if="info.id" @click="showevidence(0)">佐证</span> -->
          </div>
        </div>

        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f"></span>省内外同类院校前来交流学习次数
          </div>
          <div class="pl16 flex align-items-center">
            <a-input-number
              v-model="info.conmunicateNum"
              precision="0"
              :disabled="isEdit"
              class="percentage-text"
            />
            <!-- <span class="percentage-sign" v-if="info.id" @click="showevidence(1)">佐证</span> -->
          </div>
        </div>
      </div>
      <!--<div class="mt30">
        <div>
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 联系电话
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              :maxLength="11"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              placeholder="请输入联系电话"
              v-model="info.phone"
              :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
            />
          </div>
        </div>
      </div>-->
      <!-- <div class="text1">申报书模板下载</div>
        <div class="flex align-items-center">
          <img class="img-box-4" src="../../assets/images/img39.png" alt="" />
          <div class="text2" style="color: #2155B5; cursor: pointer">
            <a
              href="/思政教育工作室项目申报书.docx"
              download="思政微课项目申报书.docx"
              style="color: #2155B5"
            >
              思政教育工作室申报书.docx</a
            >
            <span class="text2">(32.2KB)</span>
          </div>
        </div>
      </div>-->
      <div class="mt30">
        <div class="form-item-upload">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span>
            申报书上传
          </div>
          <div class="pl16">
            <a-upload
              :file-list="fileList"
              disabled="disabled"
              :remove="(file, fileList) => handleRemove(file, fileList)"
              :before-upload="(file, fileList) => beforeUpload(file, fileList)"
              accept=".pdf"
            >
              <a-button :disabled="isEdit || loading" :loading="loading">
                <a-icon type="upload" />上传附件
              </a-button>
              <span class="text2">注：请上传pdf格式的文件</span>
            </a-upload>
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item-upload">
          <div class="main-text-style">
            <span style="color: #f6350f"></span>
            建设方案上传
          </div>
          <div class="pl16">
            <a-upload
              :file-list="fileList1"
              :disabled="isEdit"
              :remove="(file, fileList) => handleRemove1(file, fileList)"
              :before-upload="(file, fileList) => beforeUpload1(file, fileList)"
              accept=".pdf"
            >
              <a-button :disabled="isEdit || loadings" :loading="loadings">
                <a-icon type="upload" />上传附件
              </a-button>
              <span class="text2">注：请上传pdf格式的文件</span>
            </a-upload>
          </div>
        </div>
      </div>
      <!-- <template v-if="!isEdit || !isbj">
        <div class="submit-btn-box">
          <div class="btn-group">
            <a-button type="primary" class="btn-action"  @click="goStep">保存</a-button>
          </div>
        </div>
      </template> -->
    </div>
  </div>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
import { postAction, putAction, fileUpdate } from "@/api/index";
import { baseURL } from "@/utils/request.js";
export default {
  name: "",
  components: {},
  props: {
    oldInfos: {
      type: Object,
    },
    isAdd: {
      type: Boolean,
    },
  },
  data() {
    return {
      isEdit: false,
      info: {
        applyType: "1",
        name: "",
        address: "",
        foundTime: "",
        applyYear: "",
        declarationName: "",
        declarationPath: "",
        acreage: "",
        belongDepartment: "",
        tsSzgzsKnow: "",
        tsSzgzsSatisfied: "",
        reportNum: "",
        conmunicateNum: "",
        activityPlanName: "",
        activityPlanPath: "",
      },
      zh_CN,
      locale,
      yearShowOne: false,
      path: baseURL,
      fileList: [],
      fileList1: [],
      loading: false,
      loadings: false,
      isbj: true,
    };
  },
  computed: {},
  watch: {
    oldInfos: {
      handler(newValue, oldValue) {
        // console.log(newValue,"11111");
        if (newValue != null) {
          this.info = newValue;
          this.oldInfos = newValue;
          if (
            this.oldInfos &&
            this.oldInfos.declarationName != "" &&
            this.oldInfos.declarationName != null &&
            this.oldInfos.declarationPath != "" &&
            this.oldInfos.declarationPath != null
          ) {
            this.fileList = [];
            let fileItem = {};
            fileItem.path = this.oldInfos.declarationPath;
            fileItem.name = this.oldInfos.declarationName;
            fileItem.uid = 1;
            this.fileList.push(fileItem);
          }
          if (
            this.oldInfos &&
            this.oldInfos.activityPlanName != "" &&
            this.oldInfos.activityPlanName != null &&
            this.oldInfos.activityPlanPath != "" &&
            this.oldInfos.activityPlanPath != null
          ) {
            this.fileList1 = [];
            let fileItem = {};
            fileItem.path = this.oldInfos.activityPlanPath;
            fileItem.name = this.oldInfos.activityPlanName;
            fileItem.uid = 2;
            this.fileList1.push(fileItem);
          }
          if (
            this.$parent.editInfo &&
            this.$parent.editInfo?.type == "preview"
          ) {
            this.isEdit = true;
          }
        }
      },
      deep: true,
    },
  },
  created() {
    // if (this.isAdd) {
    //   this.isEdit = true;
    //   return;
    // }
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
  },
  destroyed() {
    sessionStorage.setItem(
      `step${this.$store.state.user.id}`,
      JSON.stringify(this.info)
    );
  },
  mounted() {
    // console.log(this.oldInfos,"3333");
    if (this.oldInfos && this.oldInfos != null) {
      this.info = this.oldInfos;
      this.normalizeApplyYear();
    }
    // let oldInfo = JSON.parse(
    //   sessionStorage.getItem(`step${this.$store.state.user.id}`)
    // );
    // if (oldInfo) {
    //   this.info.id = oldInfo.id;
    //   this.info.name = oldInfo.name;
    //   this.info.address = oldInfo.address;
    //   this.info.foundTime = oldInfo.foundTime;
    //   this.info.applyYear = oldInfo.applyYear;
    //   this.info.declarationName = oldInfo.declarationName;
    //   this.info.declarationPath = oldInfo.declarationPath;
    //   this.info.acreage = oldInfo.acreage;
    //   this.info.belongDepartment = oldInfo.belongDepartment;
    // }
    this.fileList = [];
    this.fileList1 = [];
    // console.log(this.oldInfo);
    let oldInfo = this.info;
    if (
      oldInfo &&
      oldInfo.declarationName != "" &&
      oldInfo.declarationName != null &&
      oldInfo.declarationPath != "" &&
      oldInfo.declarationPath != null
    ) {
      let fileItem = {};
      fileItem.path = oldInfo.declarationPath;
      fileItem.name = oldInfo.declarationName;
      fileItem.uid = 1;
      this.fileList.push(fileItem);
    }
    if (
      this.oldInfos &&
      this.oldInfos.declarationName != "" &&
      this.oldInfos.declarationName != null &&
      this.oldInfos.declarationPath != "" &&
      this.oldInfos.declarationPath != null
    ) {
      this.fileList = [];
      let fileItem = {};
      fileItem.path = this.oldInfos.declarationPath;
      fileItem.name = this.oldInfos.declarationName;
      fileItem.uid = 1;
      this.fileList.push(fileItem);
    }
    if (
      this.oldInfos &&
      this.oldInfos.activityPlanName != "" &&
      this.oldInfos.activityPlanName != null &&
      this.oldInfos.activityPlanPath != "" &&
      this.oldInfos.activityPlanPath != null
    ) {
      this.fileList1 = [];
      let fileItem = {};
      fileItem.path = this.oldInfos.activityPlanPath;
      fileItem.name = this.oldInfos.activityPlanName;
      fileItem.uid = 2;
      this.fileList1.push(fileItem);
    }
  },
  methods: {
    edit() {
      this.isbj = false;
      this.isEdit = false;
      this.$emit("isbj");
    },
    toYearMoment(value) {
      if (value === null || value === undefined || value === "") return "";
      if (moment.isMoment(value)) {
        return value.isValid() ? value : "";
      }
      const s = String(value).trim();
      if (/^\d{4}$/.test(s)) {
        return moment(s, "YYYY");
      }
      const m = moment(value);
      return m.isValid() ? moment(String(m.year()), "YYYY") : "";
    },
    normalizeApplyYear() {
      if (!this.info) return;
      this.info.applyYear = this.toYearMoment(this.info.applyYear);
    },
    openChangeOne(status) {
      if (status) {
        this.normalizeApplyYear();
        this.$nextTick(() => {
          this.yearShowOne = true;
        });
      }
    },
    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleRemove1(file, fileList) {
      this.fileLis1t = this.fileList1.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList1.indexOf(file);
      const newFileList = this.fileList1.slice();
      newFileList.splice(index, 1);
      this.fileList1 = newFileList;
    },
    beforeUpload1(file, fileList) {
      this.handleUpload1(file);
      return false;
    },
    handleUpload1(file) {
      if (this.fileList1.length >= 1) {
        this.$message.error("建设方案只能上传一个文件,请移除后再上传");
        return;
      }
      this.loadings = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.fileList1.push(fileItem);
          this.oldInfos.activityPlanName = fileItem.path;
          this.oldInfos.activityPlanPath = fileItem.name;
          this.loadings = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },
    beforeUpload(file, fileList) {
      this.handleUpload(file);
      return false;
    },
    handleUpload(file) {
      if (this.fileList.length >= 1) {
        this.$message.error("申报书只能上传一个文件,请移除后再上传");
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.fileList.push(fileItem);
          this.loading = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },
    // 得到年份选择器的值
    panelChangeOne(value) {
      if (!value) {
        this.info.applyYear = "";
      } else if (moment.isMoment(value)) {
        this.info.applyYear = String(value.year());
      } else {
        const m = moment(value);
        this.info.applyYear = m.isValid() ? String(m.year()) : "";
      }
      this.yearShowOne = false;
    },
    goStep() {
      console.log("11111", this.info.foundTime);
      if ((this.info && this.info.name == "") || this.info.name == undefined) {
        this.$message.info("请填写工作室名称");
        return false;
      } else if (
        (this.info && this.info.applyYear === "") ||
        this.info.applyYear == undefined
      ) {
        this.$message.info("请选择申报年份");
        return false;
      } else if (
        (this.info && this.info.address === "") ||
        this.info.address == undefined
      ) {
        this.$message.info("请填写工作室地点");
        return false;
      }
      if (
        (this.info && this.info.acreage === "") ||
        this.info.acreage == undefined
      ) {
        this.$message.info("请填写思政教育工作室面积");
        return false;
      } else {
        let telStr = /^(0*[1-9]\d*\.?\d+|[1-9]\d*)$/;
        if (!telStr.test(this.info.acreage)) {
          this.$message.info("输入的思政教育工作室面积格式不正确");
          return false;
        }
      }
      if (
        (this.info && this.info.belongDepartment === "") ||
        this.info.belongDepartment == undefined
      ) {
        this.$message.info("请填写思政教育工作室所属部门");
        return false;
      }
      if (
        (this.info && this.info.foundTime === "") ||
        this.info.foundTime == undefined
      ) {
        this.$message.info("请选择工作室建设日期");
        return false;
      }
      //    else {
      //      var telStr = /^[1]([3-9])[0-9]{9}$/;
      //      if (!telStr.test(this.info.phone)) {
      //        this.$message.info("请输入正确格式手机号");
      //        return false;
      //      }
      //    }

      if (this.fileList.length == 0) {
        this.$message.info("请上传申报书");
        return false;
      }
      this.isEdit = false;
      const dateObj = new Date(this.info.foundTime);
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1; // 月份是从 0 开始的，所以要加 1
      const date = dateObj.getDate();
      const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${date
        .toString()
        .padStart(2, "0")}`;

      let params = {
        applyType: this.info.applyType,
        name: this.info.name,
        address: this.info.address,
        foundTime: formattedDate,
        applyYear: new Date(this.info.applyYear).getFullYear() + "",
        id: this.info.id,
        declarationName: this.fileList[0].name,
        declarationPath: this.fileList[0].path,
        acreage: this.info.acreage,
        belongDepartment: this.info.belongDepartment,
      };
      this.info.declarationName = this.fileList[0].name;
      this.info.declarationPath = this.fileList[0].path;
      //     console.log(params);
      postAction("/lx/lxApply/szAdd", params).then((res) => {
        if (res.code == 200) {
          //              this.visible = false;
          //              this.$message.success("添加成功");
          this.info.id = res.result.id;
          window.sessionStorage.setItem(
            `step${this.$store.state.user.id}`,
            this.info.id
          );
          // console.log(res.result);
          this.$emit("goStep", this.info);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onClean() {
      this.isEdit = false;
    },
  },
};
</script>

<style scoped lang="scss">
.card-item {
  background: #ffffff;
  box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
  padding: 37px 20px;
  box-sizing: border-box;
  margin-bottom: 24px;
  .title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    border-bottom: 1px solid #d9d9d9;
    .title-text {
      color: #2155b5;
      font-size: 20px;
      font-weight: bold;
      height: 40px;
      line-height: 40px;
      border-bottom: 3px solid #2155b5;
      padding: 0px 4px;
    }
    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.mt30 {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .form-item {
    display: flex;
    align-items: center;
    width: 50%;
    margin-bottom: 10px;
    .main-text-style {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #121212;
      margin-bottom: 0!important;
      // margin-bottom: 15px;
      width: 165px;
      text-align: right;
      padding-right: 10px;
      box-sizing: border-box;
    }
    .pl16 {
      width: calc(100%- 235px);
    }
    .form-item-right {
      width: 100%;
    }
    // .form-item-right {
    //   width: 240px;
    // }
  }
  .form-item-upload {
    display: flex;
    align-items: center;
    .main-text-style {
      font-size: 19px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 15px;
      width: 165px;
      text-align: right;
      padding-right: 10px;
      box-sizing: border-box;
    }
    .form-item-right {
      width: 240px;
    }
  }
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .btn-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 240px;
    margin-top: 50px;
    .btn-action {
      width: 116px;
      height: 40px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      line-height: 38px;
      text-align: center;
    }
  }
}

.input-style-2 {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
// /deep/ .ant-calendar-picker {
//   width: 50%;
// }
/deep/ .ant-input {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.plflex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb15 {
  margin: 20px;
  width: 165px;
}
.mb15-item {
  border-bottom: 1px solid #e4e0e0;
  padding-bottom: 30px;
  margin-bottom: 30px;
}

.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin: 14px 0 15px 10px;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.file-input-box {
  color: #2155b5;
}
.file {
  position: relative;
  width: 156px;
  height: 40px;
  background: #fff;
  border: 1px solid #2155b5;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #575757;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  margin-bottom: 15px;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: rgba(218, 218, 218, 0.2);
  color: #000;
  text-decoration: none;
}
.percentage-text {
  width: 86%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.percentage-sign {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  // color: #999;
  margin: 14px 0 15px 10px;
  color: #e5914b;
  cursor: pointer;
}
</style>
